import { useContext } from 'react';
import WatsonApi from "../../backends/WatsonApi";
import {StoreContext} from "../../stores/StoreLoader";
import {observer} from "mobx-react";
import FontAwesome from "../utilities/FontAwesome";
import NotificationManager from "../notifications/NotificationManager";
import styles from "../../pages/styles/MainGridPage.module.scss";


const FollowButton = observer(() => {
    const {userStore, organizationStore} = useContext(StoreContext);
    const toggleFollowing = async () => {
        try {
            const client = await WatsonApi(organizationStore.currentOrganization.id, userStore.id, );
            const response = await client.toggle_follow.toggle_follow_toggle_follow_organization({
                "itemname": organizationStore.currentOrganization.id,
            });
        } catch (e) {
            console.error(e);
            NotificationManager.error("Unable to follow.\nError: " + e);
        } finally {
            const newState = !userStore.follower;
            userStore.setPermissions({
                follower: newState,
            })
            if (newState === true) {
                NotificationManager.success("You are now following this organization.");
            } else {
                NotificationManager.success("You are no longer following this organization.");
            }
        }
    }

    let followIcon,
        followText;

    if (userStore.follower) {
        followIcon = <FontAwesome prefix={'fas'} name={'fa-star'} id="sb-follow-button-icon"/>;
        followText = <div className={styles.hiddenWhenSmall} id="sb-follow-button-text" aria-label="Click to stop following">Following</div>;
    } else if (userStore.id && userStore.viewer && ['district', 'school', 'classroom', 'group', 'section',
        'department', 'organization', 'team', 'activity'].includes(organizationStore.currentOrganization.type)) {
        followIcon = <FontAwesome name={'fa-star'} prefix={'far'} id="sb-follow-button-icon"/>;
        followText = <div className={styles.hiddenWhenSmall} id="sb-follow-button-text" aria-label="Click to follow">Follow</div>;
    } else {
        return <span />
    }

    return <a href="#" onClick={toggleFollowing}
              className={`btn btn-default pull-right ${styles.classroomFollowFloatingButton}`} role="button">
        {followIcon}
        {followText}
    </a>;
})

export default FollowButton;
